export interface ABTestConfig {
  id: string;
  variants: Record<string, number>;
  analytics: {
    event: string;
    param?: string;
  };
}

export const AB_TESTS = {
  only_residences_text: {
    id: 'only_residences_text',
    variants: {
      a: 50,
      b: 50
    }
  }
};

export type TestId = (typeof AB_TESTS)[keyof typeof AB_TESTS]['id'];
